import { fetchData } from "../../shared/fetchData";
import {
  CREATE_TEACHER,
  TEACHER_OVERALL_REPORT,
} from "../../constants/apiUrls"; // working
import { roles } from "../../constants/roles";
import actionTypes from "./actionTypes";
import { getStudents } from "./teacher";
import { getTeachers } from "./admin";
import { GlobalStore } from "../../shared/token";
import Locale from "../../locales";

export const isAuthenticated = (value) => {
  return {
    type: actionTypes.IS_AUTHENTICATED,
    value,
  };
};

export const authStart = () => {
  return {
    type: actionTypes.AUTH_START,
  };
};

export const authSuccess = (message) => {
  return {
    type: actionTypes.AUTH_SUCCESS,
    data: message,
  };
};

export const authFail = (errMessage) => {
  return {
    type: actionTypes.AUTH_FAIL,
    data: errMessage,
  };
};

export const clearAuthError = () => {
  return {
    type: actionTypes.CLEAR_AUTH_ERROR,
  };
};

export const clearAuthSuccess = () => {
  return {
    type: actionTypes.CLEAR_AUTH_SUCCESS,
  };
};

export const getRole = (role) => {
  return {
    type: actionTypes.GET_ROLE,
    role,
  };
};

export const setCurrentUser = (user, tokenId) => {
  return {
    type: actionTypes.SET_USER,
    user,
    tokenId,
  };
};

export const onSignOut = () => {
  return {
    type: actionTypes.SIGN_OUT,
  };
};

export const clearAuthState = () => {
  return {
    type: actionTypes.CLEAR_AUTH_REDUCER_STATE,
  };
};

export const setTeacherMessage = (message) => {
  return {
    type: actionTypes.SET_TEACHER_MESSAGE,
    data: message,
  };
};

export const teacherOverallReport = (teacherId) => {
  return (dispatch) => {
    dispatch(authStart());
    fetchData(
      "POST",
      TEACHER_OVERALL_REPORT,
      { teacherId },
      (res) => {
        dispatch({
          type: actionTypes.OVERALL_PERFORMANCE,
          data: res.overallPerformanceReport,
        });
        dispatch(authSuccess());
      },
      (err) => {
        dispatch(authFail(err.message));
      },
    );
  };
};

export const onSignIn = (emailId, token) => {
  GlobalStore.set("token", token);
  return (dispatch) => {
    dispatch(setCurrentUser(emailId, token));
    dispatch(authStart());
    fetchData(
      "POST",
      CREATE_TEACHER,
      { emailId },
      (res) => {
        const { role } = res.data;
        if (role === roles.ADMIN) {
          dispatch(isAuthenticated("true"));
          dispatch(authSuccess(Locale.t("signed_in_successfully")));
          dispatch(getRole(roles.ADMIN));
          dispatch(getTeachers());
        } else if (role === roles.TEACHER) {
          dispatch(setTeacherMessage(res.data.teacherMessage));
          dispatch(getStudents(emailId));
          dispatch(authSuccess(Locale.t("signed_in_successfully")));
          dispatch(isAuthenticated(true));
          dispatch(getRole(roles.TEACHER));
        }
      },
      (err) => {
        dispatch(authFail(err.message));
      },
    );
  };
};

export const logoutStart = () => {
  return {
    type: actionTypes.LOGOUT_START,
  };
};

export const logoutSuccess = () => {
  return {
    type: actionTypes.LOGOUT_SUCCESS,
  };
};

export const logoutFail = (errMessage) => {
  return {
    type: actionTypes.LOGOUT_FAIL,
    data: errMessage,
  };
};
